export default __webpack_public_path__ + "static/media/home.1948bdf6.svg";